import {Component} from 'san';
import styles from './style/index.module.less';

export default class GuideAction extends Component {
    static template = require('./index.html');

    attached() {
        const qrShowSec = this.data.get('data.qrShowSec');
        this.storeDispatch('guideAction:log', {
            type: 'pcball_show',
        });
        setTimeout(() => {
            this.storeDispatch('guideAction:log', {
                type: 'pcQRCode_show',
            });
            this.data.set('showQR', false);
        }, +qrShowSec * 1000);
    }

    initData() {
        return {
            styles,
            showGuide: true,
            showQR: true,
            intoPageTime: new Date().getTime(),
        };
    }

    closeGuide() {
        this.data.set('showGuide', false);
        const curTimeTamp = new Date().getTime();
        this.storeDispatch('guideAction:log', {
            type: 'pcclose_click',
        });
        localStorage.setItem('LANDINGPAGE_BOTTOM_ACTION', curTimeTamp);
    }

    handleMouseEnter() {
        this.storeDispatch('guideAction:log', {
            type: 'pcballhover_show',
        });
        const curTime = new Date().getTime();
        const intoPageTime = this.data.get('intoPageTime');
        const qrShowSec = this.data.get('data.qrShowSec');

        if (+qrShowSec * 1000 + intoPageTime >= curTime) {
            // 二维码在页面加载qrShowSec秒后消失, 消失后鼠标hover再展现
            return;
        }
        this.data.set('showQR', true);
        this.storeDispatch('guideAction:log', {
            type: 'pcQRCode_show',
        });
    }

    handleMouseLeave() {
        this.data.set('showQR', false);
    }

    handleClickBall() {
        this.storeDispatch('guideAction:log', {
            type: 'pcball_click',
        });
    }
}
